const filterChipsLabels = {
  PLP: {
    PLP_sort_filter: {
      lbl_clear: 'Clear All',
    },
  },
};

export default filterChipsLabels;
